import { observer } from "mobx-react";
import * as React from "react";
import { Dropdown, Input, Label } from "semantic-ui-react";
import {
  CURRENCY_DELETE_OPTION,
  CURRENCY_LIST,
  CURRENCY_LIST_DELETE
} from "../../../constants";
import {
  ICurrencyModel,
  ICurrencyRateModel
} from "../../../modules/share/CurrencyModel";

export interface IInput {
  fieldname?: string;
  value: string;
}
interface ICurrenecyInput {
  value?: number;
  setField?: (value: number) => void;
  currency?: string;
  onChangeDropdown?: (value: string, index: number) => void;
  onSelectedDelete?: () => void;
  numberOfdecimal?: number;
  disabled?: boolean;
  hideDelete?: boolean;
  domestic?: boolean;
  abroad?: boolean;
  size?: "mini" | "small" | "large" | "big" | "huge" | "massive";
  fluid?: boolean;
  style?: any;
  currenecyAbroadValue?: string;
  currencyYear?: number;
  currencyStore?: ICurrencyModel;
  delimiterPadding?: number;
  dicimalPadding?: number;
  required?: boolean;
  readOnly?: boolean;
}

@observer
class CurrenecyInput extends React.Component<ICurrenecyInput> {
  public state = { isFocused: false, canSetValue: true, delimiterLength: 0 };
  private dicimalPadding = 2;
  private re = "";
  private regx = new RegExp(this.re, "g");
  public componentDidMount() {
    const {
      currencyStore,
      currencyYear,
      domestic,
      delimiterPadding,
      dicimalPadding
    } = this.props;
    this.dicimalPadding = dicimalPadding || 2;
    this.re =
      "\\d(?=(\\d{" +
      (delimiterPadding || 3) +
      "})+" +
      ((dicimalPadding || 2) > 0 ? "\\." : "$") +
      ")";
    this.regx = new RegExp(this.re, "g");
    try {
      if (
        !domestic &&
        currencyYear &&
        currencyStore &&
        currencyStore.currency.length === 0
      ) {
        currencyStore.getCurrency(currencyYear);
      }
    } catch (e) {
      console.log(e);
    }
  }

  public render() {
    const {
      value,
      currency,
      fluid,
      style,
      domestic,
      abroad,
      currenecyAbroadValue,
      hideDelete,
      disabled,
      currencyStore,
      required,
      readOnly
    } = this.props;
    const textSize: any = this.textSize();
    const currenecyDomestic = "THB";
    const currenecyAbroad = currenecyAbroadValue || "USD";
    return (
      <Input
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        fluid={fluid}
        style={style}
        label={
          domestic || abroad ? (
            <Label>{domestic ? currenecyDomestic : currenecyAbroad}</Label>
          ) : (
            <Dropdown
              disabled={disabled}
              search
              value={currency}
              options={this.renderDropDownOptions()}
              onChange={(event: any, data: any) =>
                this.onChangeDropdown(data.value)
              }
              loading={currencyStore ? currencyStore.loading : false}
            />
          )
        }
        labelPosition="right"
        placeholder={"0.00"}
        size={textSize}
        value={
          this.state.isFocused
            ? this.renderValue(value)
            : this.tryConvert(value)
        }
        onChange={(event: any, data: any) =>
          this.state.canSetValue ? this.onSetField(event, data.value) : null
        }
        onKeyDown={(event: any) => this.onKeyDown(event)}
        type="text"
        onFocus={(event: any) => this.setState({ isFocused: true })}
        onBlur={(event: any) => this.setState({ isFocused: false })}
        className="input-currenecy"
        action
      />
    );
  }

  private renderValue = (value?: any) => {
    if (value) {
      try {
        const decimalValue = value.toFixed(Math.max(0, ~~this.dicimalPadding!));
        return decimalValue.replace(this.regx, "$&,");
      } catch {
        return value.replace(this.regx, "$&,");
      }
    } else {
      return "";
    }
  };

  private tryConvert = (value?: number) => {
    const { numberOfdecimal } = this.props;

    if (value) {
      // Check undefined value
      const _value = value !== undefined ? value.toString() : "";
      // remove Unformat charactor
      const clearingValue: string = _value.replace(/[^0-9.-]+/g, "");
      // Set parseFloat value to inputValue
      const input = parseFloat(clearingValue);

      if (numberOfdecimal === 0) {
        return new Intl.NumberFormat("th-TH").format(input);
      } else {
        return new Intl.NumberFormat("th-TH", {
          minimumFractionDigits: numberOfdecimal || 2,
          maximumFractionDigits: numberOfdecimal || 2
        }).format(input);
      }
    } else {
      return "";
    }
  };

  private onSetField = (event: any, value: string) => {
    const { setField } = this.props;

    // stop jumping cursor
    const caret = event.target.selectionStart;
    const element = event.target;

    // clear comma
    let clearingValue: string = value.replace(/[^0-9.-]+/g, "");
    // check if match currency condition
    const match = clearingValue.match(this.regx);
    // set end cursor
    const end =
      match && match!.length > this.state.delimiterLength ? caret + 1 : caret;
    window.requestAnimationFrame(() => {
      element.selectionStart = end;
      element.selectionEnd = end;
    });

    if (setField) {
      const countDot = clearingValue.match(/\./g) || 0;
      if (clearingValue.length > 1 && countDot == 0) {
        // check if remove dot
        clearingValue = clearingValue.slice(0, -2);
      } else {
        // check if key more than 1 dot
        clearingValue = clearingValue.replace(/\.+/g, ".");
      }
      // set value
      if (+clearingValue < Number.MAX_SAFE_INTEGER) {
        setField(+clearingValue || 0);
        this.setState({ delimiterLength: match ? match.length : 0 });
      }
    }
  };

  private onKeyDown = (event: any) => {
    if (event.keyCode === 190) {
      this.setState({ canSetValue: false });
    } else {
      this.setState({ canSetValue: true });
    }
  };

  private onChangeDropdown = (value: string) => {
    const { onChangeDropdown, onSelectedDelete } = this.props;
    if (value === "Delete" && onSelectedDelete) {
      onSelectedDelete();
    } else {
      if (onChangeDropdown) {
        onChangeDropdown(value, 0);
      }
    }
  };

  private textSize = () => {
    const { size } = this.props;
    return size;
  };

  private renderDropDownOptions = () => {
    const { currencyStore, currencyYear, hideDelete } = this.props;
    if (currencyYear && currencyStore) {
      const dropdownOption = currencyStore.currency.map(
        (currency: ICurrencyRateModel, index: number) => currency.dropdownOption
      );
      return hideDelete
        ? dropdownOption
        : [...dropdownOption, CURRENCY_DELETE_OPTION];
    } else {
      return hideDelete ? CURRENCY_LIST : CURRENCY_LIST_DELETE;
    }
  };
}

export default CurrenecyInput;
